import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/(shop)/error.tsx");
